import { render, staticRenderFns } from "./MetricsUserPerformance.vue?vue&type=template&id=05fbd876&scoped=true"
import script from "./MetricsUserPerformance.vue?vue&type=script&lang=js"
export * from "./MetricsUserPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbd876",
  null
  
)

export default component.exports